// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ddf886b0","703":"f301ff00","787":"dd35c722"}[chunkId] + ".chunk.js";
};